/** Wrong artwork uses the same server-owned matrix as missing files. Merely
 * opening this form never converts the issue or captures an overwrite stamp. */
import { useTranslation } from 'react-i18next';
import { PrintFileSelfHealForm } from './PrintFileSelfHealForm';

interface Props {
  issueId: string;
  blockedSku: string | null;
  shopifyProductId?: number | string | null;
  issueOrganizationId?: string | null;
  onResolved: () => void;
  onCancel: () => void;
}

export function WrongDataUploadForm({ blockedSku, ...props }: Props) {
  const { t } = useTranslation('production');
  return (
    <div className="space-y-3">
      {blockedSku && (
        <p className="text-base text-muted-foreground">
          {t('issues.printFiles.printData.skuContext')}{' '}
          <span className="font-mono text-foreground">{blockedSku}</span>
        </p>
      )}
      <p className="text-base text-amber-700 dark:text-amber-300">
        {t('issues.printFiles.upload.correctedFormatsRequired')}
      </p>
      <PrintFileSelfHealForm
        {...props}
        resolvedToastKey="issues.printFiles.wrongDataUpload.resolved"
      />
    </div>
  );
}
